'use strict';

module.exports = function (text, replacements) {

  if (!this.opts.texts) return '';

  var text = this.opts.texts[text];

  if (replacements) for (var key in replacements) {
    // console.log(key)
    text = text.replace('{' + key + '}', replacements[key]);
  }

  return text;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/display.js
// module id = 71
// module chunks = 0